// extracted by extract-css-chunks-webpack-plugin
module.exports = {"barChart":"barChart___8BuMJ","link":"link___1aLxf"};